import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const allergyCaptureSecureFormDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.allergy,
  componentType: LAYOUT_COMPONENT_TYPE.allergyCaptureSecureForm,
  registryBlockKey: REGISTRY_BLOCK.presentation.allergyCaptureSecureForm,
  displayOrder: 6,
  content: {
    heading: loc3(
      'Allergien & Ernährungsangaben',
      'Allergies & dietary notes',
      'Dị ứng & lưu ý dinh dưỡng',
    ),
    supporting: loc3(
      'Teilen Sie Unverträglichkeiten sicher vor Ihrem Besuch mit.',
      'Share intolerances securely before your visit.',
      'Chia sẻ thông tin dị ứng an toàn trước khi đến.',
    ),
    consent: loc3(
      'Ich stimme der Verarbeitung meiner Angaben für die Reservierung zu.',
      'I agree to process this data for reservation handling.',
      'Tôi đồng ý xử lý dữ liệu này cho đặt chỗ.',
    ),
    ctaLabel: loc3('Sicher senden', 'Send securely', 'Gửi bảo mật'),
  },
  media: {},
};
